import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'; 

const FaqListSkeleton = () => {
  return (
    <div className="card">
      <div className='card-header border-0 pt-5'>
        <div className='d-flex align-items-center gap-10'>
          <h3 className='card-title align-items-start flex-column'>
            <Skeleton width={100} height={24} />
          </h3>
        </div>
        <div className='card-toolbar'>
          <Skeleton height={40} width={100} />
        </div>
      </div>
      <div className='p-10'>
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index}>
            <Skeleton height={50} width="100%" className="mb-2" />
            <Skeleton height={20} width="80%" className="mb-3" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FaqListSkeleton;
